var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vxe-grid',{ref:"vxeGrid",attrs:{"auto-resize":"","highlight-hover-row":"","data":_vm.tableData,"toolbar-config":{
      slots: {
        buttons: 'toolbar_form',
      },
    },"columns":_vm.tableColumns,"height":300,"size":"small","resizable":"","border":"","header-cell-style":function () {
        return {
          backgroundColor: '#bd94c1',
          color: '#ffffff',
        }
      }},scopedSlots:_vm._u([{key:"toolbar_form",fn:function(){return [_c('div',{staticClass:"side-frame-success"},[_c('span',{staticStyle:{"font-size":"14px","color":"#606266"}},[_vm._v(" "+_vm._s(_vm.$l('INDEX.table_label_product_information') || '产品信息')+" ")])])]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }